import React, { useEffect, useState, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ArrowLeft, Camera, Plus, Instagram, Facebook, Youtube, Twitter, ChevronDown, ChevronUp, GripVertical, X, Linkedin, TrendingUp as TikTok, MessageCircle as Threads, Upload, Trash2, Image as ImageIcon } from 'lucide-react';
import { SectionCard } from '../components/editor/SectionCard';
import { DevicePreview } from '../components/editor/DevicePreview';
interface EditorCard {
  id: string;
  title: string;
  url: string;
  description: string;
  image: string;
  enabled: boolean;
  price?: string;
  status?: string;
}
interface EditorSection {
  id: string;
  type: 'listings-videos' | 'custom-links' | 'reviews';
  title: string;
  description: string;
  layout: string;
  cards: EditorCard[];
  collapsed: boolean;
}
export function DashboardEditProfile() {
  // Profile state
  const [profileImage, setProfileImage] = useState('https://images.unsplash.com/photo-1560250097-0b93528c311a?w=400&h=400&fit=crop');
  const [showProfileImageModal, setShowProfileImageModal] = useState(false);
  const profileFileInputRef = useRef<HTMLInputElement>(null);
  const [displayName, setDisplayName] = useState('Marcus Chen');
  const [title, setTitle] = useState('Senior real estate advisor');
  const [brokerage, setBrokerage] = useState('Compass Real Estate · The Chen Group');
  const [shortUrl, setShortUrl] = useState('marcuschen');
  const [location, setLocation] = useState('San Francisco Bay Area');
  const [dreNumber, setDreNumber] = useState('02145678');
  const [email, setEmail] = useState('marcus@chengroup.com');
  const [phone, setPhone] = useState('(415) 555-0198');
  const [address, setAddress] = useState('1200 Market St, San Francisco, CA 94102');
  const [websites, setWebsites] = useState([{
    id: 1,
    title: 'Compass',
    url: 'compass.com/marcuschen'
  }, {
    id: 2,
    title: 'Website',
    url: 'marcuschen.com'
  }, {
    id: 3,
    title: 'Realtor.com',
    url: 'realtor.com/marcuschen'
  }]);
  const [reviews, setReviews] = useState([{
    id: 1,
    platform: 'Zillow',
    rating: '4.9',
    count: '142',
    url: '',
    enabled: true
  }, {
    id: 2,
    platform: 'Google',
    rating: '4.8',
    count: '89',
    url: '',
    enabled: true
  }, {
    id: 3,
    platform: 'Yelp',
    rating: '4.7',
    count: '56',
    url: '',
    enabled: true
  }, {
    id: 4,
    platform: 'Facebook',
    rating: '4.8',
    count: '34',
    url: '',
    enabled: true
  }]);
  const [aiSummaryEnabled, setAiSummaryEnabled] = useState(true);
  const [socialLinks, setSocialLinks] = useState([{
    id: 1,
    platform: 'Instagram',
    url: 'instagram.com/marcuschen',
    enabled: true,
    icon: Instagram
  }, {
    id: 2,
    platform: 'Facebook',
    url: 'facebook.com/marcuschen',
    enabled: true,
    icon: Facebook
  }, {
    id: 3,
    platform: 'YouTube',
    url: 'youtube.com/@marcuschen',
    enabled: true,
    icon: Youtube
  }, {
    id: 4,
    platform: 'X (Twitter)',
    url: 'x.com/marcuschen',
    enabled: false,
    icon: Twitter
  }]);
  const [showAddSocialModal, setShowAddSocialModal] = useState(false);
  const availableSocialPlatforms = [{
    name: 'Instagram',
    icon: Instagram
  }, {
    name: 'Facebook',
    icon: Facebook
  }, {
    name: 'YouTube',
    icon: Youtube
  }, {
    name: 'X (Twitter)',
    icon: Twitter
  }, {
    name: 'LinkedIn',
    icon: Linkedin
  }, {
    name: 'TikTok',
    icon: TikTok
  }, {
    name: 'Threads',
    icon: Threads
  }];
  const [sections, setSections] = useState<EditorSection[]>([{
    id: 'section-reviews',
    type: 'reviews',
    title: 'Reviews',
    description: 'Client reviews from across the web',
    layout: 'list',
    cards: [],
    collapsed: false
  }, {
    id: 'section-1',
    type: 'listings-videos',
    title: 'Featured Listings',
    description: 'My current and upcoming properties',
    layout: 'small-card',
    collapsed: false,
    cards: [{
      id: 'card-1',
      title: '1428 Pacific Ave',
      url: 'https://zillow.com/listing-1',
      description: '4 bed \u00b7 3.5 bath \u00b7 2,850 sqft',
      image: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=200&h=200&fit=crop',
      enabled: true,
      price: '$2.45M',
      status: 'Active'
    }, {
      id: 'card-2',
      title: '850 Marina Blvd',
      url: 'https://zillow.com/listing-2',
      description: '3 bed \u00b7 2 bath \u00b7 2,100 sqft',
      image: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=200&h=200&fit=crop',
      enabled: true,
      price: '$3.1M',
      status: 'Coming Soon'
    }, {
      id: 'card-3',
      title: '245 Cole St',
      url: 'https://zillow.com/listing-3',
      description: '3 bed \u00b7 2.5 bath \u00b7 1,950 sqft',
      image: 'https://images.unsplash.com/photo-1600607687931-cebf004f560c?w=200&h=200&fit=crop',
      enabled: true,
      price: '$1.9M',
      status: 'Open House'
    }]
  }, {
    id: 'section-2',
    type: 'custom-links',
    title: 'Resources',
    description: 'Helpful links and tools',
    layout: 'list',
    collapsed: false,
    cards: [{
      id: 'card-4',
      title: 'Book a Consultation',
      url: 'calendly.com/marcuschen',
      description: 'Schedule a free 30-minute consultation',
      image: '',
      enabled: true
    }, {
      id: 'card-5',
      title: 'First-Time Buyer Guide',
      url: 'marcuschen.com/guide',
      description: 'Everything you need to know about buying your first home',
      image: '',
      enabled: true
    }]
  }]);
  const [showAddSectionMenu, setShowAddSectionMenu] = useState(false);
  const [draggedSectionId, setDraggedSectionId] = useState<string | null>(null);
  const locationState = useLocation();
  useEffect(() => {
    if (locationState.hash) {
      const hash = locationState.hash.replace('#', '');
      let targetId = '';
      if (hash === 'listing' || hash === 'listings' || hash === 'video' || hash === 'videos') {
        targetId = 'section-listings-videos';
      } else if (hash === 'link' || hash === 'links') {
        targetId = 'section-custom-links';
      } else if (hash === 'reviews') {
        targetId = 'section-reviews';
      }
      if (targetId) {
        setTimeout(() => {
          const element = document.getElementById(targetId);
          if (element) {
            element.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          }
        }, 300);
      }
    }
  }, [locationState.hash]);
  const handleSectionUpdate = (id: string, updates: Partial<EditorSection>) => {
    setSections(prev => prev.map(section => section.id === id ? {
      ...section,
      ...updates
    } : section));
  };
  const handleSectionDelete = (id: string) => {
    setSections(prev => prev.filter(section => section.id !== id));
  };
  const handleCardUpdate = (sectionId: string, cardId: string, updates: Partial<EditorCard>) => {
    setSections(prev => prev.map(section => section.id === sectionId ? {
      ...section,
      cards: section.cards.map(card => card.id === cardId ? {
        ...card,
        ...updates
      } : card)
    } : section));
  };
  const handleCardDelete = (sectionId: string, cardId: string) => {
    setSections(prev => prev.map(section => section.id === sectionId ? {
      ...section,
      cards: section.cards.filter(card => card.id !== cardId)
    } : section));
  };
  const handleCardAdd = (sectionId: string, cardData: Omit<EditorCard, 'id' | 'enabled'>) => {
    setSections(prev => prev.map(section => section.id === sectionId ? {
      ...section,
      cards: [...section.cards, {
        ...cardData,
        id: `card-${Date.now()}`,
        enabled: true
      }]
    } : section));
  };
  const handleCardReorder = (sectionId: string, fromIndex: number, toIndex: number) => {
    setSections(prev => prev.map(section => {
      if (section.id !== sectionId) return section;
      const newCards = [...section.cards];
      const [movedCard] = newCards.splice(fromIndex, 1);
      newCards.splice(toIndex, 0, movedCard);
      return {
        ...section,
        cards: newCards
      };
    }));
  };
  const handleAddSection = (type: 'listings-videos' | 'custom-links') => {
    const newSection: EditorSection = {
      id: `section-${Date.now()}`,
      type,
      title: type === 'listings-videos' ? 'New Listings Section' : 'New Links Section',
      description: 'Add a description',
      layout: type === 'listings-videos' ? 'small-card' : 'list',
      collapsed: false,
      cards: []
    };
    setSections(prev => [...prev, newSection]);
    setShowAddSectionMenu(false);
  };
  const handleSectionDragStart = (e: React.DragEvent, sectionId: string) => {
    setDraggedSectionId(sectionId);
    e.dataTransfer.effectAllowed = 'move';
  };
  const handleSectionDragOver = (e: React.DragEvent) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = 'move';
  };
  const handleSectionDrop = (e: React.DragEvent, targetSectionId: string) => {
    e.preventDefault();
    if (!draggedSectionId || draggedSectionId === targetSectionId) {
      setDraggedSectionId(null);
      return;
    }
    const fromIndex = sections.findIndex(s => s.id === draggedSectionId);
    const toIndex = sections.findIndex(s => s.id === targetSectionId);
    if (fromIndex !== -1 && toIndex !== -1) {
      const newSections = [...sections];
      const [movedSection] = newSections.splice(fromIndex, 1);
      newSections.splice(toIndex, 0, movedSection);
      setSections(newSections);
    }
    setDraggedSectionId(null);
  };
  const handleSocialDelete = (id: number) => {
    setSocialLinks(prev => prev.filter(link => link.id !== id));
  };
  const socialBaseUrls: Record<string, string> = {
    Instagram: 'instagram.com/',
    Facebook: 'facebook.com/',
    YouTube: 'youtube.com/@',
    'X (Twitter)': 'x.com/',
    LinkedIn: 'linkedin.com/in/',
    TikTok: 'tiktok.com/@',
    Threads: 'threads.net/@'
  };
  const handleAddSocial = (platformName: string) => {
    const platform = availableSocialPlatforms.find(p => p.name === platformName);
    if (!platform) return;
    const newLink = {
      id: Date.now(),
      platform: platformName,
      url: socialBaseUrls[platformName] || '',
      enabled: true,
      icon: platform.icon
    };
    setSocialLinks(prev => [...prev, newLink]);
    setShowAddSocialModal(false);
  };
  const handleProfileImageUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      if (file.size > 5 * 1024 * 1024) {
        alert('File size must be less than 5MB');
        return;
      }
      const url = URL.createObjectURL(file);
      setProfileImage(url);
      setShowProfileImageModal(false);
    }
  };
  const handleAddWebsite = () => {
    if (websites.length >= 3) return;
    setWebsites([...websites, {
      id: Date.now(),
      title: 'New Website',
      url: ''
    }]);
  };
  return <div className="flex h-full min-h-screen" data-id="element-532">
      <div className="flex-1 max-w-3xl border-r border-brand-light bg-brand-offwhite" data-id="element-533">
        <div className="p-8" data-id="element-534">
          <Link to="/admin" className="inline-flex items-center gap-2 text-sm text-brand-muted hover:text-brand-dark mb-8 transition-colors" data-id="element-535">
            <ArrowLeft size={16} data-id="element-536" />
            Back to profile
          </Link>

          <h1 className="text-3xl font-serif font-semibold text-brand-dark mb-8" data-id="element-537">
            Edit Profile
          </h1>

          <section id="photo" className="bg-white rounded-2xl border border-brand-light shadow-sm p-6 mb-8" data-id="element-538">
            <h2 className="text-lg font-medium text-brand-dark mb-6" data-id="element-539">
              Profile Details
            </h2>

            <div className="flex items-center gap-6 mb-8" data-id="element-540">
              <div className="relative w-24 h-24 rounded-full overflow-hidden border border-brand-light group cursor-pointer bg-brand-offwhite flex items-center justify-center" onClick={() => setShowProfileImageModal(true)} data-id="element-541">
                {profileImage ? <img src={profileImage} alt={displayName} className="w-full h-full object-cover" data-id="element-542" /> : <ImageIcon size={32} className="text-brand-light" data-id="element-543" />}
                <div className="absolute inset-0 bg-black/40 flex flex-col items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-544">
                  <Camera size={20} className="text-white mb-1" data-id="element-545" />
                  <span className="text-[10px] text-white font-medium" data-id="element-546">
                    Change
                  </span>
                </div>
              </div>
            </div>

            <div className="space-y-4" data-id="element-547">
              <div className="grid grid-cols-2 gap-4" data-id="element-548">
                <div data-id="element-549">
                  <label className="block text-xs font-medium text-brand-muted mb-1.5" data-id="element-550">
                    Display Name
                  </label>
                  <input type="text" value={displayName} onChange={e => setDisplayName(e.target.value)} className="w-full bg-white border border-brand-light rounded-xl px-4 py-3 text-sm focus:border-brand-forest focus:ring-1 focus:ring-brand-forest/20 outline-none transition-colors" data-id="element-551" />
                </div>
                <div data-id="element-552">
                  <label className="block text-xs font-medium text-brand-muted mb-1.5" data-id="element-553">
                    Title
                  </label>
                  <input type="text" value={title} onChange={e => setTitle(e.target.value)} className="w-full bg-white border border-brand-light rounded-xl px-4 py-3 text-sm focus:border-brand-forest focus:ring-1 focus:ring-brand-forest/20 outline-none transition-colors" data-id="element-554" />
                </div>
              </div>

              <div data-id="element-555">
                <label className="block text-xs font-medium text-brand-muted mb-1.5" data-id="element-556">
                  Brokerage
                </label>
                <input type="text" value={brokerage} onChange={e => setBrokerage(e.target.value)} className="w-full bg-white border border-brand-light rounded-xl px-4 py-3 text-sm focus:border-brand-forest focus:ring-1 focus:ring-brand-forest/20 outline-none transition-colors" data-id="element-557" />
              </div>

              <div data-id="element-558">
                <label className="block text-xs font-medium text-brand-muted mb-1.5" data-id="element-559">
                  Short URL
                </label>
                <div className="flex items-center bg-white border border-brand-light rounded-xl overflow-hidden focus-within:border-brand-forest focus-within:ring-1 focus-within:ring-brand-forest/20 transition-colors" data-id="element-560">
                  <span className="px-4 py-3 bg-brand-offwhite border-r border-brand-light text-sm text-brand-muted font-mono" data-id="element-561">
                    eaves.pro/
                  </span>
                  <input type="text" value={shortUrl} onChange={e => setShortUrl(e.target.value)} className="flex-1 px-4 py-3 text-sm outline-none font-mono" data-id="element-562" />
                </div>
              </div>

              <div className="grid grid-cols-2 gap-4" data-id="element-563">
                <div data-id="element-564">
                  <label className="block text-xs font-medium text-brand-muted mb-1.5" data-id="element-565">
                    Location
                  </label>
                  <input type="text" value={location} onChange={e => setLocation(e.target.value)} className="w-full bg-white border border-brand-light rounded-xl px-4 py-3 text-sm focus:border-brand-forest focus:ring-1 focus:ring-brand-forest/20 outline-none transition-colors" data-id="element-566" />
                </div>
                <div data-id="element-567">
                  <label className="block text-xs font-medium text-brand-muted mb-1.5" data-id="element-568">
                    DRE Number
                  </label>
                  <input type="text" value={dreNumber} onChange={e => setDreNumber(e.target.value)} className="w-full bg-white border border-brand-light rounded-xl px-4 py-3 text-sm focus:border-brand-forest focus:ring-1 focus:ring-brand-forest/20 outline-none transition-colors font-mono" data-id="element-569" />
                </div>
              </div>

              <div data-id="element-570">
                <label className="block text-xs font-medium text-brand-muted mb-1.5" data-id="element-571">
                  Email
                </label>
                <input type="email" value={email} onChange={e => setEmail(e.target.value)} className="w-full bg-white border border-brand-light rounded-xl px-4 py-3 text-sm focus:border-brand-forest focus:ring-1 focus:ring-brand-forest/20 outline-none transition-colors" data-id="element-572" />
              </div>

              <div data-id="element-573">
                <label className="block text-xs font-medium text-brand-muted mb-1.5" data-id="element-574">
                  Phone
                </label>
                <input type="tel" value={phone} onChange={e => setPhone(e.target.value)} className="w-full bg-white border border-brand-light rounded-xl px-4 py-3 text-sm focus:border-brand-forest focus:ring-1 focus:ring-brand-forest/20 outline-none transition-colors" data-id="element-575" />
              </div>

              <div data-id="element-576">
                <label className="block text-xs font-medium text-brand-muted mb-1.5" data-id="element-577">
                  Address
                </label>
                <input type="text" value={address} onChange={e => setAddress(e.target.value)} className="w-full bg-white border border-brand-light rounded-xl px-4 py-3 text-sm focus:border-brand-forest focus:ring-1 focus:ring-brand-forest/20 outline-none transition-colors" data-id="element-578" />
              </div>
            </div>
          </section>

          <section className="bg-white rounded-2xl border border-brand-light shadow-sm p-6 mb-8" data-id="element-579">
            <div className="flex items-center justify-between mb-6" data-id="element-580">
              <h2 className="text-lg font-medium text-brand-dark" data-id="element-581">
                Social Links
              </h2>
              <button onClick={() => setShowAddSocialModal(true)} className="inline-flex items-center gap-1.5 text-sm text-brand-forest font-medium hover:text-brand-forestHover transition-colors" data-id="element-582">
                <Plus size={16} data-id="element-583" />
                Add social
              </button>
            </div>

            <div className="space-y-3" data-id="element-584">
              {socialLinks.map(link => {
              const Icon = link.icon;
              return <div key={link.id} className="flex items-center gap-4 p-4 bg-brand-offwhite/50 border border-brand-light rounded-xl" data-id="element-585">
                    <div className="w-8 h-8 rounded-full bg-white border border-brand-light flex items-center justify-center shrink-0" data-id="element-586">
                      <Icon size={14} className="text-brand-muted" data-id="element-587" />
                    </div>
                    <div className="flex-1" data-id="element-588">
                      <input type="text" value={link.url} onChange={e => {
                    const newLinks = [...socialLinks];
                    const idx = newLinks.findIndex(l => l.id === link.id);
                    newLinks[idx].url = e.target.value;
                    setSocialLinks(newLinks);
                  }} className="w-full bg-transparent text-sm outline-none text-brand-dark placeholder:text-brand-light" placeholder={`${link.platform} URL`} data-id="element-589" />
                    </div>
                    <button className={`w-10 h-6 rounded-full transition-colors relative ${link.enabled ? 'bg-brand-forest' : 'bg-gray-200'}`} onClick={() => {
                  const newLinks = [...socialLinks];
                  const idx = newLinks.findIndex(l => l.id === link.id);
                  newLinks[idx].enabled = !newLinks[idx].enabled;
                  setSocialLinks(newLinks);
                }} data-id="element-590">
                      <div className={`w-4 h-4 rounded-full bg-white absolute top-1 transition-transform ${link.enabled ? 'left-5' : 'left-1'}`} data-id="element-591"></div>
                    </button>
                    <button onClick={() => handleSocialDelete(link.id)} className="p-1.5 text-brand-muted hover:text-red-500 hover:bg-red-50 rounded-lg transition-colors" data-id="element-592">
                      <X size={16} data-id="element-593" />
                    </button>
                  </div>;
            })}
            </div>
          </section>

          <section className="bg-white rounded-2xl border border-brand-light shadow-sm p-6 mb-8" data-id="element-594">
            <div className="flex items-center justify-between mb-6" data-id="element-595">
              <h2 className="text-lg font-medium text-brand-dark" data-id="element-596">Websites</h2>
              {websites.length < 3 && <button onClick={handleAddWebsite} className="inline-flex items-center gap-1.5 text-sm text-brand-forest font-medium hover:text-brand-forestHover transition-colors" data-id="element-597">
                  <Plus size={16} data-id="element-598" />
                  Add website
                </button>}
            </div>

            <div className="space-y-3" data-id="element-599">
              {websites.map(website => <div key={website.id} className="flex items-center gap-4 p-4 bg-brand-offwhite/50 border border-brand-light rounded-xl" data-id="element-600">
                  <div className="flex-1 grid grid-cols-2 gap-4" data-id="element-601">
                    <input type="text" value={website.title} onChange={e => {
                  const newWebsites = [...websites];
                  const idx = newWebsites.findIndex(w => w.id === website.id);
                  newWebsites[idx].title = e.target.value;
                  setWebsites(newWebsites);
                }} className="w-full bg-transparent text-sm outline-none text-brand-dark placeholder:text-brand-light border-b border-transparent hover:border-brand-light focus:border-brand-forest transition-colors" placeholder="Title (e.g. Website)" data-id="element-602" />
                    <input type="text" value={website.url} onChange={e => {
                  const newWebsites = [...websites];
                  const idx = newWebsites.findIndex(w => w.id === website.id);
                  newWebsites[idx].url = e.target.value;
                  setWebsites(newWebsites);
                }} className="w-full bg-transparent text-sm outline-none text-brand-dark placeholder:text-brand-light border-b border-transparent hover:border-brand-light focus:border-brand-forest transition-colors font-mono" placeholder="URL" data-id="element-603" />
                  </div>
                  <button onClick={() => setWebsites(websites.filter(w => w.id !== website.id))} className="p-1.5 text-brand-muted hover:text-red-500 hover:bg-red-50 rounded-lg transition-colors" data-id="element-604">
                    <X size={16} data-id="element-605" />
                  </button>
                </div>)}
              {websites.length === 0 && <p className="text-sm text-brand-muted text-center py-4" data-id="element-606">
                  No websites added.
                </p>}
            </div>
          </section>

          <section id="sections" className="mb-8" data-id="element-607">
            <div className="flex items-center justify-between mb-6" data-id="element-608">
              <h2 className="text-xl font-serif font-medium text-brand-dark" data-id="element-609">
                Your Sections
              </h2>
              <div className="relative" data-id="element-610">
                <button onClick={() => setShowAddSectionMenu(!showAddSectionMenu)} className="inline-flex items-center gap-1.5 px-4 py-2 bg-brand-forest text-white rounded-full text-sm font-medium hover:bg-brand-forestHover transition-colors" data-id="element-611">
                  <Plus size={16} data-id="element-612" />
                  Add Section
                  <ChevronDown size={14} data-id="element-613" />
                </button>

                {showAddSectionMenu && <div className="absolute right-0 top-full mt-2 w-56 bg-white rounded-xl border border-brand-light shadow-premium py-2 z-10" data-id="element-614">
                    <button onClick={() => handleAddSection('listings-videos')} className="w-full px-4 py-2 text-left text-sm text-brand-dark hover:bg-brand-offwhite transition-colors" data-id="element-615">
                      + Listings & Videos
                    </button>
                    <button onClick={() => handleAddSection('custom-links')} className="w-full px-4 py-2 text-left text-sm text-brand-dark hover:bg-brand-offwhite transition-colors" data-id="element-616">
                      + Custom Links
                    </button>
                  </div>}
              </div>
            </div>

            <div className="space-y-4" data-id="element-617">
              {sections.map(section => section.type === 'reviews' ? <div key={section.id} draggable onDragStart={e => handleSectionDragStart(e, section.id)} onDragOver={handleSectionDragOver} onDrop={e => handleSectionDrop(e, section.id)} className={`bg-white rounded-2xl border border-brand-light shadow-sm transition-all ${draggedSectionId === section.id ? 'opacity-50' : ''}`} data-id="element-618">
                    <div className="p-6" data-id="element-619">
                      <div className="flex items-start gap-3 mb-4" data-id="element-620">
                        <button type="button" className="mt-2 text-brand-light hover:text-brand-muted cursor-grab active:cursor-grabbing transition-colors" data-id="element-621">
                          <GripVertical size={20} data-id="element-622" />
                        </button>
                        <div className="flex-1" data-id="element-623">
                          <div className="flex items-center gap-2" data-id="element-624">
                            <h2 className="text-lg font-medium text-brand-dark" data-id="element-625">
                              Reviews
                            </h2>
                            <span className="text-xs font-medium px-2 py-1 rounded-full bg-brand-sage text-brand-forest border border-brand-sage" data-id="element-626">
                              Reviews
                            </span>
                          </div>
                          <p className="text-sm text-brand-muted mt-1" data-id="element-627">
                            Toggle review sites and set URLs
                          </p>
                        </div>
                        <div className="flex items-center gap-1 shrink-0" data-id="element-628">
                          <button type="button" onClick={() => handleSectionUpdate(section.id, {
                      collapsed: !section.collapsed
                    })} className="p-2 text-brand-muted hover:text-brand-dark hover:bg-brand-offwhite rounded-lg transition-colors" data-id="element-629">
                            {section.collapsed ? <ChevronDown size={18} data-id="element-630" /> : <ChevronUp size={18} data-id="element-631" />}
                          </button>
                        </div>
                      </div>

                      {!section.collapsed && <div className="border-t border-brand-light pt-4" data-id="element-632">
                          <div className="space-y-3 mb-6" data-id="element-633">
                            {reviews.map(review => <div key={review.id} className="flex items-center gap-4 p-4 bg-brand-offwhite/50 border border-brand-light rounded-xl" data-id="element-634">
                                <div className="w-24 shrink-0" data-id="element-635">
                                  <span className="text-sm font-medium text-brand-dark" data-id="element-636">
                                    {review.platform}
                                  </span>
                                  {review.enabled && <p className="text-[11px] text-brand-muted mt-0.5" data-id="element-637">
                                      {review.rating} ★ · {review.count} reviews
                                    </p>}
                                </div>
                                <div className="flex-1" data-id="element-638">
                                  <input type="text" value={review.url} onChange={e => {
                          const newReviews = [...reviews];
                          const idx = newReviews.findIndex(r => r.id === review.id);
                          newReviews[idx].url = e.target.value;
                          setReviews(newReviews);
                        }} className="w-full bg-transparent text-sm outline-none text-brand-dark placeholder:text-brand-light border-b border-transparent hover:border-brand-light focus:border-brand-forest transition-colors font-mono" placeholder="Review page URL" data-id="element-639" />
                                </div>
                                <button className={`w-10 h-6 rounded-full transition-colors relative shrink-0 ${review.enabled ? 'bg-brand-forest' : 'bg-gray-200'}`} onClick={() => {
                        const newReviews = [...reviews];
                        const idx = newReviews.findIndex(r => r.id === review.id);
                        newReviews[idx].enabled = !newReviews[idx].enabled;
                        setReviews(newReviews);
                      }} data-id="element-640">
                                  <div className={`w-4 h-4 rounded-full bg-white absolute top-1 transition-transform ${review.enabled ? 'left-5' : 'left-1'}`} data-id="element-641"></div>
                                </button>
                              </div>)}
                          </div>

                          <div className="flex items-center justify-between pt-4 border-t border-brand-light" data-id="element-642">
                            <div data-id="element-643">
                              <p className="text-sm font-medium text-brand-dark" data-id="element-644">
                                AI-Generated Summary
                              </p>
                              <p className="text-xs text-brand-muted" data-id="element-645">
                                Show an AI summary of your reviews
                              </p>
                            </div>
                            <button className={`w-10 h-6 rounded-full transition-colors relative ${aiSummaryEnabled ? 'bg-brand-forest' : 'bg-gray-200'}`} onClick={() => setAiSummaryEnabled(!aiSummaryEnabled)} data-id="element-646">
                              <div className={`w-4 h-4 rounded-full bg-white absolute top-1 transition-transform ${aiSummaryEnabled ? 'left-5' : 'left-1'}`} data-id="element-647"></div>
                            </button>
                          </div>
                        </div>}
                    </div>
                  </div> : <SectionCard key={section.id} section={section} onUpdate={handleSectionUpdate} onDelete={handleSectionDelete} onCardUpdate={handleCardUpdate} onCardDelete={handleCardDelete} onCardAdd={handleCardAdd} onCardReorder={handleCardReorder} onDragStart={handleSectionDragStart} onDragOver={handleSectionDragOver} onDrop={handleSectionDrop} isDragging={draggedSectionId === section.id} data-id="element-648" />)}
            </div>
          </section>

          <div className="flex justify-end" data-id="element-649">
            <button className="px-6 py-3 bg-brand-forest hover:bg-brand-forestHover text-white font-medium rounded-xl transition-colors shadow-sm" data-id="element-650">
              Save changes
            </button>
          </div>
        </div>
      </div>

      <DevicePreview profileImage={profileImage} displayName={displayName} title={title} brokerage={brokerage} location={location} dreNumber={dreNumber} email={email} phone={phone} address={address} websites={websites} reviews={reviews} aiSummaryEnabled={aiSummaryEnabled} sections={sections} socialLinks={socialLinks} data-id="element-651" />

      {/* Add Social Modal */}
      {showAddSocialModal && <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50" onClick={() => setShowAddSocialModal(false)} data-id="element-652">
          <div className="bg-white rounded-2xl p-6 max-w-md w-full mx-4" onClick={e => e.stopPropagation()} data-id="element-653">
            <div className="flex items-center justify-between mb-4" data-id="element-654">
              <h3 className="text-lg font-medium text-brand-dark" data-id="element-655">
                Add Social Link
              </h3>
              <button onClick={() => setShowAddSocialModal(false)} className="p-1 text-brand-muted hover:text-brand-dark transition-colors" data-id="element-656">
                <X size={20} data-id="element-657" />
              </button>
            </div>
            <div className="space-y-2" data-id="element-658">
              {availableSocialPlatforms.map(platform => {
            const Icon = platform.icon;
            const alreadyAdded = socialLinks.some(l => l.platform === platform.name);
            return <button key={platform.name} onClick={() => !alreadyAdded && handleAddSocial(platform.name)} disabled={alreadyAdded} className={`w-full flex items-center gap-3 p-3 rounded-xl border transition-colors ${alreadyAdded ? 'bg-brand-offwhite border-brand-light text-brand-muted cursor-not-allowed' : 'bg-white border-brand-light hover:border-brand-forest hover:bg-brand-sage/20'}`} data-id="element-659">
                    <div className="w-8 h-8 rounded-full bg-brand-offwhite flex items-center justify-center" data-id="element-660">
                      <Icon size={16} className="text-brand-muted" data-id="element-661" />
                    </div>
                    <span className="text-sm font-medium" data-id="element-662">{platform.name}</span>
                    {alreadyAdded && <span className="ml-auto text-xs text-brand-muted" data-id="element-663">
                        Added
                      </span>}
                  </button>;
          })}
            </div>
          </div>
        </div>}

      {/* Profile Image Modal */}
      {showProfileImageModal && <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50" onClick={() => setShowProfileImageModal(false)} data-id="element-664">
          <div className="bg-white rounded-2xl p-6 max-w-sm w-full mx-4" onClick={e => e.stopPropagation()} data-id="element-665">
            <div className="flex items-center justify-between mb-4" data-id="element-666">
              <h3 className="text-lg font-medium text-brand-dark" data-id="element-667">
                Profile Image
              </h3>
              <button onClick={() => setShowProfileImageModal(false)} className="p-1 text-brand-muted hover:text-brand-dark transition-colors" data-id="element-668">
                <X size={20} data-id="element-669" />
              </button>
            </div>

            <div className="space-y-3" data-id="element-670">
              <input type="file" ref={profileFileInputRef} onChange={handleProfileImageUpload} accept="image/jpeg, image/png, image/webp" className="hidden" data-id="element-671" />

              <button onClick={() => profileFileInputRef.current?.click()} className="w-full flex items-center gap-3 p-3 rounded-xl border border-brand-light bg-white hover:border-brand-forest hover:bg-brand-sage/20 transition-colors" data-id="element-672">
                <div className="w-8 h-8 rounded-full bg-brand-offwhite flex items-center justify-center" data-id="element-673">
                  <Upload size={16} className="text-brand-forest" data-id="element-674" />
                </div>
                <span className="text-sm font-medium text-brand-dark" data-id="element-675">
                  Upload new photo
                </span>
              </button>

              {profileImage && <button onClick={() => {
            setProfileImage('');
            setShowProfileImageModal(false);
          }} className="w-full flex items-center gap-3 p-3 rounded-xl border border-brand-light bg-white hover:border-red-500 hover:bg-red-50 transition-colors" data-id="element-676">
                  <div className="w-8 h-8 rounded-full bg-red-50 flex items-center justify-center" data-id="element-677">
                    <Trash2 size={16} className="text-red-500" data-id="element-678" />
                  </div>
                  <span className="text-sm font-medium text-red-600" data-id="element-679">
                    Remove photo
                  </span>
                </button>}

              <p className="text-xs text-brand-muted text-center pt-2" data-id="element-680">
                JPG, PNG or WebP. Max size 5MB.
              </p>
            </div>
          </div>
        </div>}
    </div>;
}